// Update Lookbook Order Fulfillment Package
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_REQUEST = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_REQUEST';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_DONE = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_DONE';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_FAILED = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_FAILED';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_RESET = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_RESET';
